import Cookies from 'js-cookie';

const banner = document.querySelector('.top-banner');
if (banner) {
  if (Cookies.get('hidebdlinfo') === undefined) {
    document.body.classList.add('has-banner');
  }

  document.querySelector('.close-banner')?.addEventListener('click', () => {
    document.body.classList.remove('has-banner');
    document.querySelector('.c-header-primary')?.style.setProperty('top', '0');
    Cookies.set('hidebdlinfo', 'true', { expires: 365 });
  });

  window.addEventListener('scroll', () => {
    if (!document.body.classList.contains('has-banner')) return;
    const newTop = banner.offsetHeight - window.scrollY;
    const header = document.querySelector('.c-header-primary');
    if (header) header.style.top = newTop + 'px';
  });
}
